import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SignupModalProvider } from './contexts/SignupModalContext';
import CookieConsent from './components/CookieConsent';
import { loadScripts } from './utils/cookieConsent';

import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsOfService from './pages/TermsOfService';
import GDPRPage from './pages/GDPRPage';

// Define your tracking scripts here
const trackingScripts = [
  // Add your analytics and marketing scripts here
  // Example:
  // { src: 'https://www.googletagmanager.com/gtag/js?id=YOUR-ID', type: 'analytics' },
  // { src: 'https://www.facebook.com/tr?id=YOUR-ID', type: 'marketing' }
];

function App() {
  useEffect(() => {
    // Load scripts based on cookie consent
    loadScripts(trackingScripts).catch(console.error);
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <SignupModalProvider>
          <Router>
            <Routes>
              {/* Public pages with main layout (header and footer) */}
              <Route path="/" element={<MainLayout />}>
                <Route index element={<HomePage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="privacy" element={<PrivacyPage />} />
                <Route path="terms" element={<TermsOfService />} />
                <Route path="gdpr" element={<GDPRPage />} />
                <Route path="signup" element={<SignupPage />} />
              </Route>
              
              {/* Auth pages without layout */}
              <Route path="login" element={<LoginPage />} />
              
              {/* Fallback route for any undefined routes */}
              <Route path="*" element={
                <div className="min-h-screen flex items-center justify-center bg-gray-50">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
                    <p className="text-xl text-gray-600 mb-8">Page not found</p>
                    <a href="/" className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition duration-200">
                      Go back home
                    </a>
                  </div>
                </div>
              } />
            </Routes>
            
            {/* Cookie Consent Component */}
            <CookieConsent />
          </Router>
        </SignupModalProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App; 